import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { DataService } from './data.service';
import { UserRole } from '../models/user-role';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ManageUserRoleService {
    url = "api/manage-roles";
    private partnerApproveSubject = new BehaviorSubject<boolean | null>(null); 
    partnerApprove = this.partnerApproveSubject.asObservable(); 

    constructor(
        private dataService: DataService,
        private commonService: CommonService,
    ) { }

    setPartnerApprove(value: boolean) {
        this.partnerApproveSubject.next(value);
    }

    async getAllRoleBasedAccess(): Promise<UserRole[]> {
        return await this.dataService.get<UserRole[]>(this.url);
    }

    async getUserPermissionsByRole(role: string): Promise<UserRole> {
        return await this.dataService.get<UserRole>(this.url + "/current-user-permissions" + "?role=" + role);
    }

    async UpdatePermissionsOfRoles(UserRolesArray: UserRole[]): Promise<Boolean> {
        return await this.dataService.post<boolean>(this.url, UserRolesArray);
    }
}
